<template>
  <div class="doomyogahome">
    <SidebarMyIrishSDate />
    <div class="main-panel">
      <NavbarMyIrishDate />
      <div class="content" style="margin-top: 50px">
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>


<script>
import $ from "jquery";
import SidebarMyIrishSDate from "@/components/partials/admin_sidebar_mid.vue";
import NavbarMyIrishDate from "@/components/partials/navbar_mid.vue";

export default {
  name: "DoOmYogaHome",
  components: { SidebarMyIrishSDate, NavbarMyIrishDate },
  data() {
    return {};
  },
  methods: {
    logout() {
      // console.log("logoutttt")
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      //  App.isLogin = false;
      this.$router.push({ name: "DoOmYogaLogin" });
      //     }
      //   }
      // })
    },
  },
  updated() {
    // alert("home updated");
    // console.log($(".nav-open"));
    console.log($(".close-layer"))
    console.log($(".close-layer").length)
    if($(".close-layer")!=null && $(".close-layer").length>0){
      $(".close-layer").click()
      $(".close-layer").remove()
    }
  },
  mounted() {
    // console.log("session ",localStorage.getItem('user'))
    var md = {
      misc: {
        navbar_menu_visible: 0,
        active_collapse: true,
        disabled_collapse_init: 0,
      },
      initMinimizeSidebar: function () {
        $("#minimizeSidebar").click(function () {
          var $btn = $(this);

          if (md.misc.sidebar_mini_active == true) {
            $("body").removeClass("sidebar-mini");
            $("#adminNavLogoImg").css("width", "100px!important");
            md.misc.sidebar_mini_active = false;
          } else {
            $("body").addClass("sidebar-mini");
            $("#adminNavLogoImg").css("width", "40px!important");
            md.misc.sidebar_mini_active = true;
          }

          // we simulate the window Resize so the charts will get updated in realtime.
          var simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event("resize"));
          }, 180);

          // we stop the simulation of Window Resize after the animations are completed
          setTimeout(function () {
            clearInterval(simulateWindowResize);
          }, 1000);
        });
      },
    };
    md.initMinimizeSidebar();

    $(".navbar-toggler").click(function () {
      // $('body').toggleClass('menu-on-left');
      // $(this).toggleClass('toggled');
      var mobile_menu_visible;
      var e;
      var $toggle = $(this),
        mobile_menu_visible =
          1 == mobile_menu_visible
            ? ($("html").removeClass("nav-open"),
              $(".close-layer").remove(),
              setTimeout(function () {
                $toggle.removeClass("toggled");
                $("body").removeClass("menu-on-left");
              }, 400),
              0)
            : (setTimeout(function () {
                $toggle.addClass("toggled");
              }, 430),
              (e = $('<div class="close-layer"></div>')),
              0 != $("body").find(".main-panel").length
                ? e.appendTo(".main-panel")
                : $("body").hasClass("off-canvas-sidebar") &&
                  e.appendTo(".wrapper-full-page"),
              setTimeout(function () {
                e.addClass("visible");
              }, 100),
              e.click(function () {
                $("html").removeClass("nav-open"),
                  (mobile_menu_visible = 0),
                  e.removeClass("visible"),
                  setTimeout(function () {
                    e.remove(), $toggle.removeClass("toggled");
                  }, 400);
              }),
              $("html").addClass("nav-open"),
              1);
    });
  },
};
</script>
<style  scoped::v-deep >
@import "css/my-irish-date-fonts.css";
@import "css/my-irish-date-styles.css";
@import "css/my-irish-date-buttons-styles.css";
@import "css/my-irish-date-calendar-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/my_irish_date/Home.vue